import { map, forEach } from 'lodash';
import { Component, ChangeDetectorRef, OnDestroy, Renderer2 } from '@angular/core';
import { takeUntil, Subject, Observable, combineLatest, map as rxMap, catchError, of } from 'rxjs';

import { CartProductInput, CartProductType, ShoppingCartType } from '@sifca-monorepo/ecommerce-generator';

import { AppService, AuthService, SharedService } from '../../../services';
import { OrdersService } from '../../../services/order/order/order.service';

declare const FB: any;

@Component({
  template: '',
})
export class BaseCartMenuComponent implements OnDestroy {
  private unsubscribeAll: Subject<any> = new Subject<any>();

  seo: any;
  items: any;
  product: any;
  totalPrice = 0;
  updateButton: any;
  posId: string = '';
  totalQunatity: number;
  authenticated: boolean;
  localShppingCart: any[];
  products: CartProductType[];
  isRemoveButtonDisabled = false;
  allProducts: CartProductInput[] = [];
  productCart$: Observable<ShoppingCartType>;

  constructor(
    protected renderer: Renderer2,
    protected appService: AppService,
    protected authService: AuthService,
    protected orderService: OrdersService,
    protected sharedService: SharedService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
      this.productCart$ = this.orderService.productCart$;
    this.sharedService.posId$.pipe(takeUntil(this.unsubscribeAll)).subscribe((posId) => {
      this.posId = posId;
    });
    this.appService.loadCart();
    this.authService.authenticated$.pipe(takeUntil(this.unsubscribeAll)).subscribe((authenticated) => {
      this.authenticated = authenticated;
      if (authenticated) {
        this.orderService.findShoppingCartByUserAndTarget(this.posId).subscribe();
      }
      this.changeDetectorRef.markForCheck();
    });

    combineLatest([this.authService.authenticated$, this.appService.items$, this.orderService.productCart$])
      .pipe(
        takeUntil(this.unsubscribeAll),
        rxMap(([authenticated, items, productCart]) => {
          if (!authenticated) {
            this.products = items;
            this.getQuantity();
            this.allProducts = map(this.products, (product) => ({
              quantity: product.quantity,
              barcode: product?.barcode?.id,
            }));
            this.orderService.calculateShoppingCart(this.allProducts).subscribe();
          } else {
            this.totalPrice = +productCart?.price.gross.afterReduction;
            this.products = productCart?.products;
            this.getQuantity();
          }
          this.changeDetectorRef.markForCheck();
        }),
      )
      .subscribe();
    this.orderService.calculatedShoppingCart$.pipe(takeUntil(this.unsubscribeAll)).subscribe((calculatedShoppingCart) => {
      if (calculatedShoppingCart) {
        this.totalPrice = +calculatedShoppingCart?.price.gross.afterReduction;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  emptyTargetCart() {
    this.orderService.emptyTargetCart().subscribe();
  }

  getQuantity() {
    this.totalQunatity = 0;
    forEach(this.products, (product) => {
      this.totalQunatity += product.quantity;
    });
    this.changeDetectorRef.markForCheck();
  }

  removeProduct(product) {
    this.isRemoveButtonDisabled = true;
    if (!this.authenticated) {
      this.allProducts = [];
      this.appService.removeItem(product);
      this.calculateTotalPrice();
    } else {
      const formValue = {
        product: product.product?.id,
        barcode: product.barcode?.id,
        quantity: 1,
      };
      this.orderService
        .removeFromCart(this.posId, formValue)
        .pipe(
          catchError(() => {
            this.isRemoveButtonDisabled = false;
            return of(null);
          }),
        )
        .subscribe((res) => {
          if (res) {
            this.isRemoveButtonDisabled = false;
            this.changeDetectorRef.markForCheck();
          }
        });
    }
  }

  calculateTotalPrice() {
    this.allProducts = [];
    forEach(this.products, (product) => {
      const value: any = {
        barcode: product.barcode.id,
        quantity: product.quantity,
      };
      this.allProducts = [...this.allProducts, value];
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
